import React, { useEffect, useState } from "react";
import { Card, Divider, Popover, Tag, Tooltip, Input, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { MoreOutlined } from "@ant-design/icons";
import moment from "moment";
import { convertEpochToTimestamp } from "../../utils";
import { filterDomainsForComponent2, getcurrentRoleValue } from "../../utils";
import MultiSelectCm from "../MultiSelectCm/MultiSelectCm";
import { editQuestionText } from "../../API/api";
import { toast } from "react-toastify";
import AttachmentBox from "../AttachmentBox/AttachmentBox";
import { Avatar, Space } from "antd";
import TagComp from "../../NewComponent/Tag/TagComp";
import Styles from "./ExpertRecordsDetailStyles.module.css";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
import { ReactComponent as FireIcon } from "./../../Icons/fire.svg";

import NewAttachmentBox from "../AttachmentBox/NewAttachmentBox";
const questionStyles = {
  fontSize: "18px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: "break-word",
  overflowWrap: "break-word",
};

const additionalContextStyles = {
  border: "1px solid rgb(246, 247, 248)",
  marginBlock: "10px",
  borderRadius: "6px",
  background: "rgb(246, 247, 248)",
  padding: "12px",
  minHeight: "48px",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
};

const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "22px",
  fontWeight: "400",
  display: "flex",
  padding: "4px",
};
export function TagCompDomain({ title, onClickFunc }) {
  const styles = {
    borderRadius: "6px",
    height: "24px",
    padding: "1px 8px",
    color: "#fff",
    textAlign: "center",
    background: "linear-gradient(90.39deg, #ff9800 0.34%, #fb8c00 99.7%)",
    fontSize: "13px",
    marginLeft: "5px",
    fontWeight: "300",
    display: "inline-flex", // Use inline-flex so width fits content
    alignItems: "center",
    cursor: onClickFunc === undefined ? "auto" : "pointer",
    whiteSpace: "nowrap", // Prevent text from wrapping
  };

  const onClickTag = (tag) => {
    if (!onClickFunc) return;
    onClickFunc(tag);
  };

  return (
    <div style={styles} onClick={() => onClickTag(title)}>
      {title}
    </div>
  );
}

export default function QuestionBox() {
  const state = useSelector((state) => state.expertRecord.clickedData);
  const [isLoading, setLoading] = React.useState(false);
  const attachmentsData = useSelector((state) => state.expertRecord);
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const { advanceFilterModalToggle, cmrIsGoBack } = bindActionCreators(
    Actions,
    dispatch,
  );
  const [isEdit, setIsEdit] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const getDomain = () => {
    let required = [];
    filterDomainsForComponent2(userState.cmTopics).filter((obj) => {
      if (obj.name === state.domain) {
        required.push(obj);
      }
    });
    return required[0];
  };
  const [updatedData, setUpdatedData] = useState({
    question: state.questionText,
    addiText: state.additionalContext,
    domain: getDomain(),
  });
  const onChangeSetEdit = () => {
    setIsEdit(!isEdit);
  };
  // const onChangeDomain=()=>{
  //   setIsEdit(!isEdit);
  // }

  const momentit = (stime) => {
    if (Number(Date.now()) - Number(stime) < 259200000) {
      return moment(new Date(Number(stime))).fromNow();
    } else {
      return moment(stime).format("MMMM DD, YYYY h:mm:ss A");
    }
  };
  const filterOptions = () => {
    return (
      <div style={{ fontWeight: "300", fontSize: "15px", color: "#2a364a" }}>
        <span
          style={{ cursor: "pointer" }}
          onClick={() =>
            advanceFilterModalToggle({
              bool: true,
              value: "reroutecm",
            })
          }
        >
          <i
            className="fa fa-retweet"
            style={{ fontSize: "20px", color: "#2a364a" }}
          ></i>
          &nbsp;Force Reroute
        </span>
        <Divider style={{ marginBlock: "5px" }} />
        <span style={{ cursor: "pointer" }} onClick={() => onChangeSetEdit()}>
          <i
            className="fa fa-pencil-square-o"
            style={{ fontSize: "20px", color: "#2a364a" }}
          ></i>
          &nbsp;Edit
        </span>
        <Divider style={{ marginBlock: "5px" }} />
        <span
          style={{ cursor: "pointer" }}
          onClick={() =>
            advanceFilterModalToggle({
              bool: true,
              value: "deleteexpertrecords",
            })
          }
        >
          <i
            className="fa fa-trash"
            style={{ fontSize: "20px", color: "#2a364a" }}
          ></i>
          &nbsp;Delete
        </span>
      </div>
    );
  };
  const onChangeDomain = (data) => {
    const matchedObject = filterDomainsForComponent2(
      userState.visibleTopics,
    ).find((item) => item.label === data.label);
    setUpdatedData({ ...updatedData, domain: matchedObject });
  };
  const onChangeQuestion = (data) => {
    setUpdatedData({ ...updatedData, question: data });
  };
  const onChangeAddiText = (data) => {
    setUpdatedData({ ...updatedData, addiText: data });
  };
  const onClickSubmit = () => {
    setLoading(true);
    let payload = {
      questionUuid: state.questionUuid,
      questionText:
        state.otherLanguageQuestionText === undefined
          ? updatedData.question
          : state.otherLanguageQuestionText,
      additionalContext: updatedData.addiText,
      domain:
        updatedData.domain.name !== undefined
          ? updatedData.domain.name
          : updatedData.domain.label,
      postedDate: state.postedDate,
    };
    editQuestionText(payload).then((res) => {
      if (res === undefined) return;
      if (res.data.success) {
        state.questionText = updatedData.question;
        state.additionalContext = updatedData.addiText;
        state.domain = updatedData.domain.name;
        setIsEdit(false);
        cmrIsGoBack(false);
        setLoading(false);
        toast.success(() => {
          return <span style={{ fontSize: "12px" }}>{res.data.message}</span>;
        });
      }
    });
  };
  const fetchImage = (key) => {
    switch (key) {
      case "csv":
        return (
          <>
            <TooltipComp title="User added QA via XLS Atomizer.">
              <i
                className="fa fa-file-excel-o"
                style={{ fontSize: "20px", color: "purple" }}
              ></i>
            </TooltipComp>
            {/* <Tooltip
             placement="bottom"
             title={() => (
               <span style={{ color: "black", fontSize: "10px" }}>
                 User added QA via XLS Atomizer
               </span>
             )}
             color="#fff"
           >
             <i
               className="fa fa-file-excel-o"
               style={{ fontSize: "20px", color: "purple" }}
             ></i>
           </Tooltip> */}
          </>
        );
      case "expert-QA":
        return (
          <>
            {/* <Tooltip
             placement="bottom"
             title={() => (
               <span style={{ color: "black", fontSize: "10px" }}>
                 User added QA via Expert role
               </span>
             )}
             color="#fff"
           >
             <i
               className="fa fa-user-plus"
               style={{ fontSize: "20px", color: "#fb7432" }}
             ></i>
           </Tooltip> */}
            <TooltipComp title={"User added QA via Expert role"}>
              <i
                className="fa fa-user-plus"
                style={{ fontSize: "20px", color: "#fb7432" }}
              ></i>
            </TooltipComp>
          </>
        );
      case "msteams":
        return (
          <>
            {/* <Tooltip
             placement="bottom"
             title={() => (
               <span style={{ color: "black", fontSize: "10px" }}>
                 User asked a question via MS Teams
               </span>
             )}
             color="#fff"
           >
             <img
               src={require("../../Images/msteams.ico")}
               style={{ width: "20px" }}
             />
           </Tooltip> */}
            <TooltipComp title={"     User asked a question via MS Teams"}>
              <img
                src={require("../../Images/msteams.ico")}
                style={{ width: "20px" }}
              />
            </TooltipComp>
          </>
        );
      case "msteams-channel":
        return (
          <>
            {/* <Tooltip
             placement="bottom"
             title={() => (
               <span style={{ color: "black", fontSize: "10px" }}>
                 User asked a question via MS Teams channel
               </span>
             )}
             color="#fff"
           >
             <img
               src={require("../../Images/msteams.ico")}
               style={{ width: "20px" }}
             />
           </Tooltip> */}

            <TooltipComp title={" User asked a question via MS Teams channel"}>
              <img
                src={require("../../Images/msteams.ico")}
                style={{ width: "20px" }}
              />
            </TooltipComp>
          </>
        );
      case "webex":
        return (
          <>
            {/* <Tooltip
             placement="bottom"
             title={() => (
               <span style={{ color: "black", fontSize: "10px" }}>
                 User asked a question via Webex
               </span>
             )}
             color="#fff"
           >
             <img
               src={require("../../Images/webex.jpg")}
               style={{ width: "20px" }}
             />
           </Tooltip> */}

            <TooltipComp title={" User asked a question via Webex"}>
              <img
                src={require("../../Images/webex.jpg")}
                style={{ width: "20px" }}
              />
            </TooltipComp>
          </>
        );
      case "webex-channel":
        return (
          <>
            {/* <Tooltip
             placement="bottom"
             title={() => (
               <span style={{ color: "black", fontSize: "10px" }}>
                 User asked a question via Webex channel
               </span>
             )}
             color="#fff"
           >
             <img
               src={require("../../Images/webex.jpg")}
               style={{ width: "20px" }}
             />
           </Tooltip> */}

            <TooltipComp title={" User asked a question via Webex channel"}>
              <img
                src={require("../../Images/webex.jpg")}
                style={{ width: "20px" }}
              />
            </TooltipComp>
          </>
        );
      case "Mobile":
        return (
          <>
            {/* <Tooltip
             placement="bottom"
             title={() => (
               <span style={{ color: "black", fontSize: "10px" }}>
                 User searched via Mobile Application
               </span>
             )}
             color="#fff"
           >
             <img
               src={require("../../Images/32x32.png")}
               style={{ width: "20px" }}
             />
           </Tooltip> */}
            <TooltipComp title={"  User searched via Mobile Application"}>
              <img
                src={require("../../Images/32x32.png")}
                style={{ width: "20px" }}
              />
            </TooltipComp>
          </>
        );
      case "slack":
        return (
          <>
            {/* <Tooltip
             placement="bottom"
             title={() => (
               <span style={{ color: "black", fontSize: "10px" }}>
                 User asked a question via Slack Vizerto bot
               </span>
             )}
             color="#fff"
           >
             <img
               src={require("../../Images/slack.png")}
               style={{ width: "20px" }}
             />
           </Tooltip> */}
            <TooltipComp title={"User asked a question via Slack Vizerto bot"}>
              <img
                src={require("../../Images/slack.png")}
                style={{ width: "20px" }}
              />
            </TooltipComp>
          </>
        );
      case "slack-channel":
        return (
          <>
            {/* <Tooltip
             placement="bottom"
             title={() => (
               <span style={{ color: "black", fontSize: "10px" }}>
                 User asked a question on slack channel
               </span>
             )}
             color="#fff"
           >
             <img
               src={require("../../Images/slack.png")}
               style={{ width: "20px" }}
             />
           </Tooltip> */}
            <TooltipComp title={"User asked a question on slack channel"}>
              <img
                src={require("../../Images/slack.png")}
                style={{ width: "20px" }}
              />
            </TooltipComp>
          </>
        );
      default:
        return <span>{key}</span>;
    }
  };
  return (
    <div className="mt-3">
      {!isEdit && (
        <Card>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                width: "97%",
                fontSize: "20px",
                display: "flex",
                fontWeight: "300",
                alignItems: "center",
              }}
            >
              {state.express && (
                //  <Tooltip placement="top"
                //    title={() => (
                //      <span style={{ color: "black", fontSize: "10px" }}>
                //        This is an urgent question
                //      </span>
                //    )}
                //    color="#fff">
                //    <div style={{ width: "2%", cursor: 'pointer' }}>
                //      <img
                //        style={{ width: "22px", height: "fit-content" }}
                //        src={require("../../Images/fire.png")}
                //      />
                //    </div>
                //  </Tooltip>
                <TooltipComp title={"This is an urgent question"}>
                  <Avatar
                    style={{ background: "#fff", marginBottom: "2px" }}
                    shape="round"
                    icon={<FireIcon />}
                  />
                </TooltipComp>
              )}
              {state.userInitiatedCuration && (
                <TooltipComp title={"Update requested for the answer"}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "start",
                      cursor: "pointer",
                    }}
                  >
                    <Tag color="rgb(108, 148, 186)">Requested Update</Tag>
                  </div>
                </TooltipComp>
                // <Tooltip placement="top"
                //   title={() => (
                //     <span style={{ color: "black", fontSize: "10px" }}>
                //       Update requested for the answer
                //     </span>
                //   )}
                //   color="#fff">

                // </Tooltip>
              )}
              <span style={questionStyles}>{state.questionText}</span>
            </div>
            <div
              style={{
                width: "2%",
                fontSize: "20px",
                textAlign: "end",
                display: "flex",
                alignItems: "center",
              }}
            >
              {state.clarifications !== undefined && (
                <span
                  style={{
                    color: `${
                      state.clarifications[0].status !== "wip"
                        ? "green"
                        : "#fd7400"
                    }`,
                    cursor: "pointer",
                  }}
                >
                  <TooltipComp title={" Show clarification asked"}>
                    <i
                      className="fa fa-question-circle"
                      onClick={() => setIsShow(!isShow)}
                    ></i>
                  </TooltipComp>
                  {/* <Tooltip
                    placement="top"
                    title={() => (
                      <span style={{ color: "black", fontSize: "10px" }}>
                        Show clarification asked
                      </span>
                    )}
                    color="#fff"
                  >
                
                  </Tooltip> */}
                </span>
              )}
              <Popover
                content={filterOptions()}
                placement={"bottom"}
                title=""
                trigger="hover"
                style={{ width: "30px" }}
              >
                <MoreOutlined style={{ cursor: "pointer" }} />
              </Popover>
            </div>
          </div>
          {isShow && (
            <div>
              <Card style={{ padding: "0px" }}>
                <ul style={{ marginLeft: "-15px" }}>
                  {state.clarifications.map((obj) => {
                    return (
                      <>
                        <span
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "bold",
                            marginLeft: "-15px",
                          }}
                        >
                          {obj.status === "wip"
                            ? "Clarification pending"
                            : "Clarification received"}
                        </span>
                        <span>
                          <li
                            style={{
                              color: `${obj.status === "wip" ? "#fd7400" : "var(--questionText_color)"}`,
                            }}
                          >
                            {obj.context}
                          </li>
                        </span>
                      </>
                    );
                  })}
                </ul>
              </Card>
            </div>
          )}
          {state.additionalContext && (
            <div className="mt-2">
              <span style={additionalContextStyles}>
                {state.additionalContext}
              </span>
            </div>
          )}
          {/* change here  */}
          <Divider style={{ marginBlock: "5px" }} />
          {attachmentsData?.seekerAttachments &&
            attachmentsData?.seekerAttachments.length > 0 &&
            attachmentsData?.seekerAttachments.map((obj, ind) => {
              return <NewAttachmentBox attachment={obj} key={ind} />;
            })}
          <div style={{ display: "flex" }}>
            <div
              style={{
                width: "50%",
                display: "flex",
                paddingBlock: "10px",
                fontSize: "14px",
                fontWeight: "300",
              }}
            >
              <div style={{ width: "20%" }}>
                <div style={textStyles}>Seeker&nbsp;</div>
                {/* Remving Tag component functionaity for now */}
                {/* <div style={textStyles}>Tags&nbsp;</div> */}
                <div style={textStyles}>Status&nbsp;</div>
              </div>
              <div>
                <div
                  style={{
                    gap: "5px",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {state.seekerName}{" "}
                  <Tag color="var(--light_color_shade)">{state.userType}</Tag>
                  {/* <TagComp key={state.userType} title={state.userType} /> */}
                </div>
                <div style={{ padding: "4px" }}>
                  {/* {(state.tags === "" || state.tags === undefined)
                   ? ""
                   : state.tags.split(",").map((tag) => {
                     return <Tag color="#808080">{tag}</Tag>;
                   })} */}
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                  >
                    {/* Removing tags functionality for now */}
                    {/* {attachmentsData?.keytags &&
                      Object.values(attachmentsData.keytags)
                        .flat()
                        .map((tag) => {
                          return <TagComp key={tag.term} title={tag.term} />;
                        })} */}
                    {!state.forVerification &&
                      state.answeredCount === 0 &&
                      state.lifeOver && (
                        <Tag color="#ba6b69" style={{ fontSize: "11px" }}>
                          Expired
                        </Tag>
                      )}
                    {state.answeredCount !== 0 && (
                      <Tag color="#5d995d" style={{ fontSize: "11px" }}>
                        {state.answeredCount} Answered
                      </Tag>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "50%",
                display: "flex",
                paddingBlock: "10px",
                fontSize: "14px",
                fontWeight: "300",
              }}
            >
              <div style={{ width: "20%" }}>
                <div style={textStyles}>Domain&nbsp;</div>
                <div style={textStyles}>Posted Date&nbsp;</div>
              </div>
              <div style={{ width: "80%" }}>
                <div style={{ padding: "4px" }}>
                  {/* <Tag color="rgba(233, 100, 67, 1)">{state.domain}</Tag> */}

                  <TagCompDomain key={state.domain} title={state.domain} />

                  {/* <span>
                 <TagComp key={state.domain} title={state.domain}/>
                 </span> */}
                </div>
                <div style={{ padding: "4px" }}>
                  {momentit(state.postedDate)}
                  {state.source !== "Vizerto" && (
                    <span
                      style={{
                        float: "inline-end",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      asked via&nbsp;{fetchImage(state.source)}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Card>
      )}
      {isEdit && (
        <Card>
          <div style={{ textAlign: "end" }}>
            <div style={{ display: "flex" }}>
              <div
                style={{ width: "10%", textAlign: "start", fontSize: "16px" }}
              >
                <span style={textStyles}>Question&nbsp;</span>
              </div>
              <div style={{ width: "90%" }}>
                {/* <Input.TextArea
                 value={updatedData.question}
                 onChange={(e) => onChangeQuestion(e.target.value)}
                 disabled={state.otherLanguageQuestionText === undefined ? false : true}
               /> */}
                <textarea
                  wrap="soft"
                  style={{
                    border: "1px solid rgb(224, 226, 230)",
                    width: "100%",
                    padding: "12px",
                    borderRadius: "6px",
                    outline: "none",
                  }}
                  rows={1}
                  type={"text"}
                  value={updatedData.question}
                  disabled={
                    state.otherLanguageQuestionText === undefined ? false : true
                  }
                  onChange={(e) => onChangeQuestion(e.target.value)}
                  minRows={2}
                />
              </div>
            </div>
            <br />
            <div style={{ display: "flex" }}>
              <div
                style={{ width: "10%", textAlign: "start", fontSize: "16px" }}
              >
                <span style={textStyles}>Additional Context&nbsp;</span>
              </div>
              <div style={{ width: "90%" }}>
                {/* <Input.TextArea
                 value={updatedData.addiText}
                 onChange={(e) => onChangeAddiText(e.target.value)}
               /> */}
                <textarea
                  wrap="soft"
                  style={{
                    border: "1px solid rgb(224, 226, 230)",
                    width: "100%",
                    padding: "12px",
                    borderRadius: "6px",
                    outline: "none",
                  }}
                  rows={1}
                  type={"text"}
                  value={updatedData.addiText}
                  //  disabled={state.otherLanguageQuestionText === undefined ? false : true}
                  onChange={(e) => onChangeAddiText(e.target.value)}
                  minRows={2}
                />
              </div>
            </div>
            <br />
            <div style={{ display: "flex" }}>
              <div
                style={{ width: "10%", textAlign: "start", fontSize: "16px" }}
              >
                <span style={textStyles}>Domain&nbsp;</span>
              </div>
              <div style={{ textAlign: "center", width: "200px" }}>
                {/* <MultiSelectCm
                 disabled={false}
                 value={updatedData.domain}
                 onChangeFunc={onChangeDomain}
                 isMulti={false}
                 options={filterDomainsForComponent2(userState.visibleTopics)}
               /> */}
                <Select
                  showSearch
                  labelInValue
                  options={filterDomainsForComponent2(userState.visibleTopics)}
                  value={updatedData.domain}
                  onChange={onChangeDomain}
                  placeholder="Select Domains"
                  popupClassName={Styles.selectCss}
                  size="middle"
                  style={{
                    width: "100%",
                    border: "none",
                    boxShadow: "0px 1px 2px 0px #1018280D",
                    fontSize: "16px",
                    textAlign: "left", // aligns selected value
                  }}
                  optionLabelProp="label" // ensures label is shown properly
                  dropdownStyle={{ textAlign: "left" }} // aligns dropdown options
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </div>
            </div>
            {!isLoading && (
              <>
                <button
                  onClick={() => onChangeSetEdit()}
                  style={{
                    padding: "8px 12px 8px 12px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    lineHeight: "24px",
                    fontWeight: 400,
                    boxShadow: " 0px 1px 2px 0px #1018280D",
                    color: "#2A364A",
                    border: "1px solid  #fff",
                    height: "40px",
                    minWidth: "88px",
                    background: " #F6F7F8",
                    marginBottom: "14px",
                    fontWeight: 400,
                    border: " 1px solid #E0E2E6",
                    marginRight: "9px",

                    //  font-weight: 400;
                  }}
                >
                  Cancel
                </button>
                {/* & nbsp; */}
                <button
                  // style={{
                  //   fontSize: "16px",
                  //   border: "1px solid green",
                  //   background: "green",
                  //   borderRadius: "4px",
                  //   color: "#fff",
                  //   paddingInline: "10px",
                  //   width: "100px",
                  //   opacity: `${updatedData.question === "" ? .7 : 1}`
                  // }}
                  style={{
                    padding: "8px 12px 8px 12px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    lineHeight: "24px",
                    fontWeight: 400,
                    boxShadow: "0px 1px 2px 0px #1018280D",
                    color: "#FFFFFF",
                    border: "1px solid  #fff",
                    height: "40px",
                    minWidth: "88px",
                    background:
                      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
                    marginBottom: "14px",
                    cursor:
                      updatedData.question === "" ? "not-allowed" : "pointer",
                  }}
                  onClick={() => onClickSubmit()}
                  disabled={updatedData.question === "" ? true : false}
                >
                  Save
                </button>
              </>
            )}
            {isLoading && (
              <>
                <button
                  // style={{
                  //   fontSize: "16px",
                  //   border: "1px solid green",
                  //   background: "green",
                  //   borderRadius: "4px",
                  //   color: "#fff",
                  //   paddingInline: "10px",
                  //   width: "100px",
                  //   opacity: `${updatedData.question === "" ? .7 : 1}`
                  // }}
                  style={{
                    padding: "8px 12px 8px 12px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    lineHeight: "24px",
                    fontWeight: 400,
                    boxShadow: "0px 1px 2px 0px #1018280D",
                    color: "#FFFFFF",
                    border: "1px solid  #fff",
                    height: "40px",
                    minWidth: "88px",
                    background:
                      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
                    marginBottom: "14px",
                    cursor: "not-allowed",
                    opacity: "0.7",
                  }}
                  onClick={() => onClickSubmit()}
                  disabled
                >
                  Saving...
                </button>
              </>
            )}
          </div>
        </Card>
      )}
    </div>
  );
}
